// extracted by mini-css-extract-plugin
export default {"SEO__title":"SEO_SEO__title__2nKMi","SEO__more":"SEO_SEO__more__1PRq3","SEO_opened":"SEO_SEO_opened__5l8fA","SEO__content":"SEO_SEO__content__3ji24"};